import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import ContentLayout from "../../Layout/ContentLayout";
import CustomCard from "../../UI/CustomCard/CustomCard";
import useService from "../../Hooks/useService";
import BusyTimeService from "../../../Services/BusyTime.service";
import ServiceResult, { Loaders } from "../../UI/ServiceResult/ServiceResult";
const MeetingAvailability = () => {
    const [busyTimeState, getBusyTimes] = useService(BusyTimeService.myBusyTimes);
    const [{ from, to }, setSelectedDates] = useState({
        // store these as numbers so that we only call useEffect when the underlying date values change, not just the date objects.
        from: moment().startOf("month").toDate().getTime(),
        to: moment().endOf("month").toDate().getTime(),
    });
    // Dynamically load this in so we don't increase our bundle size for a calendar not many people will see.
    const [calendarState, loadCalendar] = useService(() => import("react-big-calendar"));
    React.useEffect(() => {
        loadCalendar();
    }, [loadCalendar]);
    React.useEffect(() => {
        getBusyTimes({
            from: new Date(from),
            to: new Date(to),
        });
    }, [getBusyTimes, from, to]);
    return (_jsx(ContentLayout, { notFluid: true, paddingBottom: true, paddingTop: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(CustomCard, { children: _jsx("div", { className: "card-body", children: _jsx(ServiceResult, { state: calendarState, children: (calendarImports) => (_jsx(ServiceResult, { state: busyTimeState, loader: Loaders.overlay(), children: (busyTimes) => (_jsx("div", { children: _jsx(calendarImports.Calendar, { events: busyTimes.map((bt) => ({
                                    start: bt.startDate,
                                    end: bt.endDate,
                                    title: "Busy",
                                })), onRangeChange: (range) => {
                                    let start;
                                    let end;
                                    if (Array.isArray(range)) {
                                        start = range[0];
                                        end = range[1];
                                    }
                                    else {
                                        start = range.start;
                                        end = range.end;
                                    }
                                    setSelectedDates({
                                        from: moment(start)
                                            .startOf("month")
                                            .toDate()
                                            .getTime(),
                                        to: moment(end).endOf("month").toDate().getTime(),
                                    });
                                }, localizer: calendarImports.momentLocalizer(moment), views: ["month", "week", "day", "agenda"], style: { height: 500 } }) })) })) }) }) }) }));
};
export default MeetingAvailability;
